<!-- 入库任务单 -->
<template>
    <div>
        <!-- 按钮组 -->
        <div class="buttons_box">
            <el-button type="primary" size="mini" class="mini_button">导入</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="warehousingSave">保存</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="warehousingDel" :disabled="warehousingForm.id ===''">删除</el-button>
            <!-- <el-button type="primary" size="mini" class="mini_button">完成</el-button>
            <el-button type="primary" size="mini" class="mini_button">车辆报备</el-button> -->
        </div>
        <!-- 表头 -->
            <el-form class="demo-form-inline warehousingForm" :inline="true" ref="warehousingForm" :model="warehousingForm" :rules="warehousingFormRules"
             size="mini" label-width="160px">
                <el-divider content-position="left">任务信息</el-divider>
                <el-form-item label="入库单号" prop="billNo"> 
                    <el-input disabled v-model="warehousingForm.billNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="入库状态" prop="taskStatus"> 
                    <el-input disabled placeholder="" v-model="warehousingForm.taskStatus"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-form-item label="单证员" prop="createUser"> 
                    <el-input disabled v-model="warehousingForm.createUser"  suffix-icon="xxxx" ></el-input>
                </el-form-item> 
                <el-form-item label="创建日期" prop="createDate"> 
                    <el-date-picker disabled v-model="warehousingForm.createDate" type="date" value-format="yyyy-MM-dd"  placeholder="" style="width:100%"> </el-date-picker>
                </el-form-item>
                <el-form-item label="计划作业日期" prop="planDate"> 
                    <el-date-picker v-model="warehousingForm.planDate" type="date" value-format="yyyy-MM-dd"  placeholder="" style="width:100%"
                    :disabled="warehousingFormExit" > </el-date-picker>
                </el-form-item>                
                <el-divider content-position="left">货物信息</el-divider>
                <el-form-item label="提单号" prop="blNo"> 
                    <el-input placeholder="请输入提单号" v-model="warehousingForm.blNo" suffix-icon="xxxx" 
                    :disabled="warehousingFormExit"></el-input>
                </el-form-item>
                <el-form-item label="保税类型" prop="isBonded"> 
                    <el-select placeholder="请选择保税类型" v-model="warehousingForm.isBonded" @change="changeIsBonded"
                    :disabled="warehousingFormExit">
                        <el-option v-for="item in bondedTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仓库" prop="ckName"> 
                    <el-select  placeholder="请选择仓库" v-model="warehousingForm.ckName" @change="changeCkName"
                    :disabled="warehousingFormExit">
                        <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="账册编号" :prop="warehousingForm.isBonded === '非保税'?'':'handbook'" > 
                    <el-select placeholder="请选择账册编号" v-model="warehousingForm.handbook" :disabled="warehousingFormExit">
                        <el-option v-for="item in handBookNoList" :key="item.bookNo" :label="item.bookNo" :value="item.bookNo"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="报关单号" :prop="warehousingForm.isBonded === '保税'?'cusDeclNo':''" > 
                    <el-input placeholder="请输入报关单号" v-model="warehousingForm.cusDeclNo" suffix-icon="xxxx" :disabled="warehousingForm.isBonded === '非保税' || warehousingFormExit"></el-input>
                </el-form-item>                    
                <el-form-item label="核注清单号" prop="invDecNo" :prop="warehousingForm.isBonded === '保税'?'invDecNo':''" > 
                    <el-input placeholder="请输入核注清单号" v-model="warehousingForm.invDecNo" suffix-icon="xxxx" :disabled="warehousingForm.isBonded === '非保税' || warehousingFormExit"></el-input>
                </el-form-item>
                <el-form-item label="委托单位" prop="customer" > 
                    <el-select filterable placeholder="请选择委托单位" v-model="warehousingForm.customer" @change="changeCustomer" :disabled="warehousingFormExit">
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="货主单位" prop="ownerName"> 
                    <el-select filterable placeholder="请选择货主单位" v-model="warehousingForm.ownerName" :disabled="warehousingFormExit">
                        <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="箱型" prop="boxType"> 
                    <el-select placeholder="请选择箱型" v-model="warehousingForm.boxType" :disabled="warehousingFormExit">
                        <el-option v-for="item in boxTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="箱量"> 
                    <!-- <el-input placeholder="请输入箱量" suffix-icon="xxxx"></el-input> -->
                </el-form-item>
                <el-form-item label="净重(总)" prop="netWeight"> 
                    <el-input disabled v-model="warehousingForm.netWeight" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="件数1(总)" prop="qty1Sum"> 
                    <el-input disabled v-model="warehousingForm.qty1Sum" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="件数2(总)" prop="qty2Sum"> 
                    <el-input  v-model="warehousingForm.qty2Sum" suffix-icon="xxxx" disabled></el-input>
                </el-form-item>
                 <el-form-item label="毛重(总)" prop="grossWeight"> 
                    <el-input :disabled="warehousingFormExit" placeholder="请输入毛重" v-model="warehousingForm.grossWeight" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="体积(总)" prop="volume"> 
                    <el-input :disabled="warehousingFormExit" placeholder="请输入体积(总)" v-model="warehousingForm.volume" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="过磅" prop="scaleNum"> 
                    <el-input :disabled="warehousingFormExit" placeholder="请输入过磅" v-model="warehousingForm.scaleNum" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="工作量" prop="workNum" > 
                    <el-input disabled placeholder="" v-model="warehousingForm.workNum" suffix-icon="xxxx"></el-input>
                </el-form-item>            
                <el-form-item label="备注" prop="remark"> 
                    <el-input :disabled="warehousingFormExit" placeholder="请输入备注" v-model="warehousingForm.remark" suffix-icon="xxxx" style="width: 550px;"></el-input>
                </el-form-item>
            </el-form>
            <!-- 表体 -->
            <el-divider content-position="left">计划信息</el-divider>
            <div class="buttons_box" style="justify-content: space-between;">
                <div>
                    <el-button type="primary" size="mini" class="mini_button" @click="addRows" :disabled="warehousingForm.id ===''">新增</el-button>
                    <el-button type="primary" size="mini" class="mini_button" @click="copyRows">复制</el-button>
                    <el-button type="primary" size="mini" class="mini_button" @click="exitRows">编辑</el-button>
                    <el-button type="primary" size="mini" class="mini_button" @click="IssueRowsSave">下发暂存</el-button>
                    <!-- <el-button type="primary" size="mini" class="mini_button" @click="delRows">删除</el-button> -->
                    <el-button type="primary" size="mini" class="mini_button" @click="getIssueAll">查询全部下发任务</el-button>
                </div>
                <vxe-toolbar ref="toolbarRef"  custom ></vxe-toolbar>
            </div>
            <!-- 货物信息列表 -->
            <vxe-table id="inWarehouseTable"  size="mini" ref="inWarehouseTable" :data="inWarehouseData" :columns="inWarehouseColumns" border stripe
            :column-config="{resizable: true,sortable: true,drag:true}"  header-align="center" :custom-config="inWarehouseCustomConfig" 
            :row-config="{ isHover: true}" :radio-config="{labelField: '', highlight: true}" @radio-change="inWarehouseRowsChange"
            max-height="250">
                <!-- 列渲染 -->
                <vxe-column type="radio" fixed="left" width="50"></vxe-column>
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column v-for="column in inWarehouseColumns" :field="column.field" :title="column.title" sortable >
                     <template #default="{ row, column }">
                        <span v-if="column.field === 'decCurrency'"> 
                            {{ row.decCurrencyName }}
                        </span>
                        <span v-else-if="column.field === 'originCountry'"> 
                            {{ row.originCountryName }}
                        </span>
                        <span v-else-if="column.field === 'lawUnitFirst'"> 
                            {{ row.lawUnitFirstName }}
                        </span>
                        <span v-else-if="column.field === 'lawUnitSecond'"> 
                            {{ row. lawUnitSecondName }}
                        </span>
                        <span v-else-if="column.field === 'decUnit'"> 
                            {{ row. decUnitName }}
                        </span>
                        <span v-else> {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
            </vxe-table>
            <!-- 下发任务列表 -->
            <el-divider content-position="left"  >作业信息</el-divider>
            <vxe-table id="IssueGoodsTable"  size="mini" ref="IssueGoodsTable" :data="IssueGoodsData" border stripe
            :column-config="{resizable: true,sortable: true}"  header-align="center" :row-config="{ isHover: true}" 
            :radio-config="{labelField: '', highlight: true}" style="margin-top: 20px;" max-height="250">
                <!-- <vxe-column type="radio" fixed="left" width="50"></vxe-column> -->
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="rowStatus" title="作业状态" width="70"></vxe-column>
                <vxe-column field="taskNo" title="作业任务单号" width="130"></vxe-column>
                <vxe-column field="blNo" title="提单号" width="120"></vxe-column>
                <vxe-column field="storekeeper" title="理货员"></vxe-column>
                <vxe-column field="goodsName" title="货物名称"></vxe-column>
                <vxe-column field="ckName" title="仓库"></vxe-column>
                <vxe-column field="place" title="库区"></vxe-column>
                <vxe-column field="location" title="库位"></vxe-column>
                <vxe-column field="driver" title="司机"></vxe-column>
                <vxe-column field="truckNo" title="车牌"></vxe-column>
                <vxe-colgroup title="任务数量">
                    <vxe-column field="netWeight" title="净重（KG）"></vxe-column>
                    <vxe-column field="qty1" title="件数1"></vxe-column>
                    <vxe-column field="qty1Unit" title="件数1单位"></vxe-column>
                    <vxe-column field="qty2" title="件数2"></vxe-column>
                    <vxe-column field="qty2Unit" title="件数2单位"></vxe-column>
                </vxe-colgroup>
                <vxe-column field="boxNo" title="箱号"></vxe-column>
                <vxe-column field="sealNo" title="铅封号"></vxe-column>
                <vxe-column field="createTime" title="创建时间" sortable  width="150"  :formatter="({ cellValue }) => cellValue ? cellValue.split('T')[0] + '  ' +  cellValue.split('T')[1] : ''" ></vxe-column>
                <vxe-column title="操作" fixed="right" width="120">
                    <template #default="{ row }">
                        <el-button type="text" :disabled=" row.rowStatus !== '暂存' " size="mini" class="mini_button" @click="IssueRows(row)">下发</el-button>
                        <el-button type="text" :disabled=" row.rowStatus === '已下发' ? false : true"  size="mini" class="mini_button" @click="completeRows(row)">完成</el-button>
                    </template>
                </vxe-column>
            </vxe-table>
            <!-- 新增货物信息弹窗 -->
            <el-dialog title="新增货物信息" width="75%" :visible.sync="addGoodsVisible" :before-close="addGoodsClose" v-dialogDrag
             :close-on-click-modal="false" >
                <el-form :model="addGoodsForm" ref="addGoodsForm" class="demo-form-inline goods_form" size="mini" label-width="90px"
                :rules="inWarehouseRules">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="作业状态" >
                                <el-input disabled v-model="addGoodsForm.rowStatus" placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="作业单号" prop="">
                                <el-input disabled v-model="addGoodsForm.mobileNo" placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="货物名称" prop="goodsName">
                                <el-select :disabled="!addGoodsExit" class="width_100" filterable :default-first-option="true" 
                                remote :remote-method="getGoodsList" placeholder="请选择货物名称" 
                                v-model="addGoodsForm.goodsName" clearable @change="goodsEnter($event)">
                                    <el-option v-for="item in goodsList" :key="item.id" :label="item.goodsName" :value="item.goodsName + '-' + item.goodsType + '-' + item.hsCode ">
                                        <span class="margin_right_20">{{ item.goodsName }}</span>
                                        <span class="margin_right_20">{{ item.goodsType }}</span> 
                                        <span >{{ item.hsCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="货物分类" prop="goodsType">
                                <el-input disabled v-model="addGoodsForm.goodsType" placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="海关编码" prop="hsCode">
                                <el-input disabled v-model="addGoodsForm.hsCode" placeholder=""></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="包装" prop="packageType">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.packageType" placeholder="请输入包装"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="规格型号" prop="spec">
                                <el-input :disabled="!addGoodsExit" v-model="addGoodsForm.spec" placeholder="请输入规格型号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="项号" prop="itemNo">
                                <el-input clearable v-model="addGoodsForm.itemNo" placeholder="请输入项号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="商品料号" prop="skuNo">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.skuNo" placeholder="请输入商品料号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="件数1" prop="qty1">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.qty1" placeholder="请输入件数"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="件数1单位" prop="qty1Unit"> 
                                <el-select :disabled="!addGoodsExit" class="width_100" filterable clearable
                                :default-first-option="true" v-model="addGoodsForm.qty1Unit" placeholder="请选择件数1单位" >
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="件数2" prop="qty2">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.qty2" placeholder="请输入件数"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="件数2单位" prop="qty2Unit"> 
                                <el-select :disabled="!addGoodsExit" class="width_100" filterable clearable
                                :default-first-option="true" v-model="addGoodsForm.qty2Unit" placeholder="请选择件数2单位" >
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                         <el-col :span="6">
                            <el-form-item label="净重(KG)" prop="netWeight">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.netWeight" placeholder="请输入净重"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"  @blur="blurNetWeight"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="体积(m³)" prop="vol">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.vol" placeholder="请输入体积"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="申报数量" :prop="warehousingForm.isBonded === '保税' ?'decNum':'' ">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.decNum" placeholder="请输入申报数量"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="申报单位" :prop="warehousingForm.isBonded === '保税' ?'decUnit':'' ">
                                <el-select :disabled="!addGoodsExit" clearable class="width_100" filterable :default-first-option="true" 
                                v-model="addGoodsForm.decUnit" placeholder="请选择申报单位" >
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="单价" :prop="warehousingForm.isBonded === '保税' ?'decPrice':''">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.decPrice" @blur="blurDecPrice"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" placeholder="请输入单价"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="申报金额" :prop="warehousingForm.isBonded === '保税' ?'decAmount':''">
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.decAmount" 
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" placeholder="请输入申报金额（总价）"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="币制" :prop="warehousingForm.isBonded === '保税' ? 'decCurrency':'' ">
                                <el-select :disabled="!addGoodsExit" clearable class="width_100" filterable :default-first-option="true" 
                                placeholder="请选择币制" v-model="addGoodsForm.decCurrency">
                                    <el-option v-for="item in currencyList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span class="margin_right_20">{{ item.codeName }}</span> 
                                        <span >{{ item.cusCode }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="原产地" prop="originCountry">
                                <el-select :disabled="!addGoodsExit" clearable class="width_100" filterable remote :remote-method="getCountryList" 
                                placeholder="请选择原产地" v-model="addGoodsForm.originCountry" :default-first-option="true">
                                        <el-option v-for="item in countryList" :key="item.codeValue" :label="item.codeValue + ' - ' + item.codeName + ' - ' + item.cusCode" :value="item.codeValue">
                                            <span class="margin_right_20">{{ item.codeValue }}</span>
                                            <span class="margin_right_20">{{ item.codeName }}</span> 
                                            <span >{{ item.cusCode }}</span>  
                                        </el-option>
                                    </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="法一数量" :prop="addGoodsForm.lawUnitFirst ? 'firstNum':'' " >
                                <el-input :disabled="!addGoodsExit" clearable v-model="addGoodsForm.firstNum" 
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" placeholder="请输入法定第一数量" ></el-input>                            
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="法一单位" prop="lawUnitFirst">
                                <el-select disabled class="width_100" filterable 
                                :default-first-option="true" v-model="addGoodsForm.lawUnitFirst" placeholder="请选择法定第一计量单位" >
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="法二数量" prop="secondNum">
                                <el-input clearable v-model="addGoodsForm.secondNum"  :disabled="addGoodsForm.lawUnitSecond && !addGoodsExit ? false:true"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" placeholder="请输入法定第二数量" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="法二单位" prop="lawUnitSecond">
                                <el-select disabled class="width_100" filterable
                                :default-first-option="true" v-model="addGoodsForm.lawUnitSecond" placeholder="请选择法定第二计量单位" >
                                    <el-option v-for="item in unitList"  :key="item.codeValue" :label="item.codeName " :value="item.codeValue">
                                        <span class="margin_right_20">{{ item.codeValue }}</span>
                                        <span >{{ item.codeName }}</span> 
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="addGoodsClose">取 消</el-button>
                    <el-button size="mini" type="primary" @click="saveAddGoods">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 下发弹出框 -->
            <el-dialog title="任务下发" width="75%" :visible.sync="IssueGoodsVisible" :before-close="IssueGoodsClose" v-dialogDrag
             :close-on-click-modal="false">
             <!-- 显示货物信息 -->
                <el-descriptions   :column="5">
                    <!-- 显示的时候使用选中行数据inWarehouseRows -->
                    <el-descriptions-item label="货物名称">{{ inWarehouseRows.goodsName }}</el-descriptions-item>
                    <el-descriptions-item label="货物分类">{{ inWarehouseRows.goodsType }}</el-descriptions-item>
                    <el-descriptions-item label="海关编码">{{  inWarehouseRows. hsCode }}</el-descriptions-item>
                    <el-descriptions-item label="规格型号">{{  inWarehouseRows.spec }}</el-descriptions-item>
                    <el-descriptions-item label="包装">{{  inWarehouseRows.packageType }}</el-descriptions-item>
                    <el-descriptions-item label="件数1">{{  inWarehouseRows.qty1 }} {{  inWarehouseRows.qty1UnitName }}</el-descriptions-item>
                    <el-descriptions-item label="件数2">{{  inWarehouseRows.qty2 }} {{  inWarehouseRows.qty2UnitName }}</el-descriptions-item>
                    <el-descriptions-item label="体积（m³）">{{  inWarehouseRows.vol }}</el-descriptions-item>
                    <el-descriptions-item label="净重（KG）">{{  inWarehouseRows.netWeight }}</el-descriptions-item>
                    <el-descriptions-item label="申报数量">{{  inWarehouseRows.decNum }} {{  inWarehouseRows.decUnitName }}</el-descriptions-item>
                    <el-descriptions-item label="单价">{{  inWarehouseRows.decPrice }} {{  inWarehouseRows.decCurrencyName }}</el-descriptions-item>
                    <el-descriptions-item label="申报金额">{{  inWarehouseRows.decAmount }} {{  inWarehouseRows.decCurrencyName }}</el-descriptions-item>
                    <el-descriptions-item label="原产地">{{  inWarehouseRows.originCountryName }}</el-descriptions-item>
                    <el-descriptions-item label="法定第一数量">{{  inWarehouseRows.firstNum }} {{  inWarehouseRows.lawUnitFirstName }}</el-descriptions-item>
                    <el-descriptions-item label="法定第二数量">{{  inWarehouseRows.secondNum }} {{  inWarehouseRows.lawUnitSecondName }}</el-descriptions-item>
                </el-descriptions>
                <!-- 下发填写表单 -->
                <el-divider content-position="left">下发信息</el-divider>
                <el-form :model="issueGoodsForm" ref="issueGoodsForm" class="demo-form-inline " size="mini" label-width="80px"
                :rules="issueGoodsFormRules">
                    <el-row>
                        <el-col :span="6">
                             <el-form-item label="理货员" prop="storekeeper">
                                <el-select class="width_100"  v-model="issueGoodsForm.storekeeper" placeholder="请选择理货员" >
                                    <el-option v-for="item in storekeeperList"  :key="item.name" :label="item.name " :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="库区" prop="place">
                                <el-select class="width_100" @change="placeEnter" v-model="issueGoodsForm.place" placeholder="请选择库区">
                                    <el-option v-for="item in placeList"  :key="item.name" :label="item.name " :value="item.name + '-' + item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="库位" prop="location">
                                <el-select class="width_100" filterable
                                    :default-first-option="true" v-model="issueGoodsForm.location" placeholder="请选择库位" >
                                    <el-option v-for="item in locationList"  :key="item.locationName" :label="item.locationName " :value="item.locationName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="司机" prop="driver">
                                <el-input v-model="issueGoodsForm.driver" placeholder="请输入司机"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="车牌" prop="truckNo">
                                <el-input v-model="issueGoodsForm.truckNo" placeholder="请输入车牌"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="箱号" prop="boxNo">
                                <el-input v-model="issueGoodsForm.boxNo" placeholder="请输入箱号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="铅封号" prop="sealNo">
                                <el-input v-model="issueGoodsForm.sealNo" placeholder="请输入铅封号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="件数1" prop="qty1">
                                  <el-input class="form_item_60"  v-model="issueGoodsForm.qty1" placeholder="请输入件数1"
                                  onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" @blur="blurQty1"></el-input>
                                  <span class="tipText">已下发：{{ inWarehouseRows.workedQty1  }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="件数2" :prop="inWarehouseRows.qty2 ? 'qty2':''">
                                <el-input :disabled="inWarehouseRows.qty2 ? false:true" class="form_item_60" 
                                v-model="issueGoodsForm.qty2" placeholder="请输入件数2"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                                <span class="tipText">已下发：{{ inWarehouseRows.workedQty2  }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="净重" prop="netWeight">
                                <el-input class="form_item_60" v-model="issueGoodsForm.netWeight" placeholder="请输入净重"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                                <span class="tipText">已下发：{{ inWarehouseRows.workedNetWeight  }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="申报数量"  :prop="inWarehouseRows.decNum ? 'decNum' : ''">
                                <el-input class="form_item_60" v-model="issueGoodsForm.decNum" placeholder="请输入申报数量"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" :disabled="inWarehouseRows.decNum ? false:true"></el-input>
                                <span class="tipText">已下发：{{ inWarehouseRows.workedDecNum  }}</span>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="法一数量" :prop="inWarehouseRows.firstNum ? 'firstNum' : ''" >
                                <el-input class="form_item_60" v-model="issueGoodsForm.firstNum" placeholder="请输入法一数量"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" :disabled="inWarehouseRows.firstNum ? false:true"></el-input>
                                <span class="tipText">已下发：{{ inWarehouseRows.workedFirstNum  }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="法二数量" :prop="inWarehouseRows.secondNum ? 'secondNum':''">
                                  <el-input :disabled="inWarehouseRows.secondNum ? false:true" class="form_item_60" 
                                  v-model="issueGoodsForm.secondNum" placeholder="请输入法二数量"
                                  onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                                  <span class="tipText">已下发：{{ inWarehouseRows.workedSecondNum  }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="体积" :prop="inWarehouseRows.vol ? 'vol':''">
                                <el-input :disabled="inWarehouseRows.vol ? false:true" class="form_item_60"
                                 v-model="issueGoodsForm.vol" placeholder="请输入体积"
                                onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"></el-input>
                                <span class="tipText">已下发：{{ inWarehouseRows.workedVol  }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <!-- 申报金额（总价），跟随件数修改 -->
                            <el-form-item label="申报金额" :prop="inWarehouseRows.decAmount ? 'decAmount' : ''" >
                                <el-input class="form_item_60" v-model="issueGoodsForm.decAmount" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')" 
                                :disabled="inWarehouseRows.decAmount ? false:true" placeholder="请输入申报金额"></el-input>
                                  <span class="tipText">已下发：{{ inWarehouseRows.workedAmount  }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" @click="IssueGoodsClose">取 消</el-button>
                    <el-button size="mini" type="primary" @click="saveIssueGoods">保 存</el-button>
                </span>
            </el-dialog>
    </div>
</template>

<script>
import userProfile from '@/mixins/userProfile.js'
import AEObasicData from '@/config/AEObasicData.js'
export default {
    name: 'inWarehouse',
    mixins: [userProfile],
    components:{
    },
    watch: { 
        inWarehouseData:{
            handler(newVal,oldVal) {
                if(newVal.length){
                    const { totalQty1,totalQty2, totalNetWeight } = newVal.reduce(
                        (acc, item) => {
                            acc.totalQty1 += item.qty1 || 0;
                            acc.totalQty2 += item.qty2 || 0;
                            acc.totalNetWeight += item.netWeight || 0;
                            return acc;
                        },
                        { totalQty1: 0,totalQty2: 0, totalNetWeight: 0 } // 初始值
                    );
                    this.warehousingForm.netWeight = totalNetWeight
                    this.warehousingForm.qty1Sum = totalQty1
                    this.warehousingForm.qty2Sum = totalQty2
                }
            }
        },
    },
    data() {
        // 自定义验证函数   下发净重
        const validateNetWeight = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入净重")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            if (value === 0) {
                return callback(new Error("不能为0")); // 不能为0
            }
            const remainingWeight = parseFloat(this.inWarehouseRows.netWeight) - parseFloat(this.inWarehouseRows.workedNetWeight)
            if (parseFloat(value) > remainingWeight) {
                return callback(new Error(`净重不能超过 ${remainingWeight}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数   下发件数1
        const validateQty1 = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入件数1")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            const remainingQty1 = parseFloat(this.inWarehouseRows.qty1) - parseFloat(this.inWarehouseRows.workedQty1)
            if (parseFloat(value) > remainingQty1) {
                return callback(new Error(`件数1不能超过 ${remainingQty1}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数   下发件数2
        const validateQty2 = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入件数2")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            const remainingQty2 = parseFloat(this.inWarehouseRows.qty2) - parseFloat(this.inWarehouseRows.workedQty2)
            if (parseFloat(value) > remainingQty2) {
                return callback(new Error(`件数2不能超过 ${remainingQty2}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数   下发申报数量
        const validateDecNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入申报数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            const remainingDecNum = parseFloat(this.inWarehouseRows.decNum) - parseFloat(this.inWarehouseRows.workedDecNum)
            if (parseFloat(value) > remainingDecNum) {
                return callback(new Error(`申报数量不能超过 ${remainingDecNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数   下发法一数量
        const validateFirstNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入法定第一数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            const remainingFirstNum = parseFloat(this.inWarehouseRows.firstNum) - parseFloat(this.inWarehouseRows.workedFirstNum)
            if (parseFloat(value) > remainingFirstNum) {
                return callback(new Error(`法定第一数量不能超过 ${remainingFirstNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数   下发法二数量
        const validateSecondNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入法定第二数量")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            const remainingSecondNum = parseFloat(this.inWarehouseRows.secondNum) - parseFloat(this.inWarehouseRows.workedSecondNum)
            if (parseFloat(value) > remainingSecondNum) {
                return callback(new Error(`法定第二数量不能超过 ${remainingSecondNum}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数   下发体积
        const validateVol = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入体积")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            const remainingVol = parseFloat(this.inWarehouseRows.vol) - parseFloat(this.inWarehouseRows.workedVol)
            if (parseFloat(value) > remainingVol) {
                return callback(new Error(`体积不能超过 ${remainingVol}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 自定义验证函数   下发申报金额
        const validateDecAmount= (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入申报金额")); // 非空校验
            }
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            const remainingDecAmount = parseFloat(this.inWarehouseRows.decAmount) - parseFloat(this.inWarehouseRows.workedAmount)
            if (parseFloat(value) > remainingDecAmount) {
                return callback(new Error(`申报金额不能超过 ${remainingDecAmount}`)); // 不能超过最大值
            }
            callback(); // 验证通过
        };
        // 新增货物时不可填0
        const inWarehouseRulesZero= (rule, value, callback) => {
            if (isNaN(value) || Number(value) === 0) {
                return callback(new Error("必须输入数字且不能为0")); // 必须是数字
            }
            callback(); // 验证通过
        };
        
        return {
            inWarehouseCustomConfig:null, // 自定义表格配置
            warehousingForm:{ // 表头
                id:'', 
                taskType: '入库', // 出入库类型
                billNo:'', // 入库单号
                taskStatus:'新建', // 状态
                createUser:'', // 单证人
                createDate:'', // 创建日期
                planDate:'', // 计划作业日期
                blNo:'', // 提单号
                isBonded:'' , // 保税属性
                handbook:'' , // 账册编号
                cusDeclNo:'', // 报关单号
                invDecNo:'', // 核注清单号
                customer:'', // 委托单位
                ownerName:'', // 货主单位
                ckName:'', // 仓库
                boxType:'', // 箱型
                boxNum:'', // 箱量
                grossWeight:'', // 毛重(总)
                netWeight:'', // 净重(总)
                qty1Sum:'', // 件数1(总)
                qty1Unit:'', // 件数1单位
                qty2Sum:'', // 件数2(总)
                qty2Unit:'', // 件数2单位
                volume:'', // 体积(总)
            },
            warehousingFormExit:false, // 是否可以编辑表头
            bondedTypeList:[], // 保税属性列表
            handBookNoList:[], // 账册编号列表
            customerList:[], // 委托单位列表
            ckNameList:[], // 仓库列表
            boxTypeList:[], // 箱型列表
            // qtyUnitList:AEObasicData.QTY_UNIT, // 件数单位
            hasHandledToken: false, // 是否处理过token
            // 表头验证规则
            warehousingFormRules:{
                blNo:[
                    { required: true, message: '请输入提单号', trigger: 'blur' }
                ],
                isBonded: [
                    { required: true, message: '请选择保税类型', trigger: 'change' }
                ],
                cusDeclNo: [
                    { required: true, message: '请输入报关单号', trigger: 'blur' }
                ],
                invDecNo: [
                    { required: true, message: '请输入核注清单号', trigger: 'blur' }
                ],
                customer: [
                    { required: true, message: '请选择委托单位', trigger: 'change' }
                ],
                ownerName: [
                    { required: true, message: '请选择货主单位', trigger: 'change' }
                ],
                ckName: [
                    { required: true, message: '请选择仓库', trigger: 'change' }
                ],
                handbook:[
                    { required: true, message: '请选择账册编号', trigger: 'change' }
                ],
            },
            // 表体数据
            inWarehouseData:[],
            //实际使用的列配置（从本地存储恢复或用默认）
            inWarehouseColumns:[],
            addGoodsExit:true, // 是否可以编辑计划行信息
            addGoodsVisible:false, // 新增货物信息弹窗显示
            goodsList:[], // 货物列表
            placeList:[], // 库区列表
            locationList:[], // 库位列表
            unitList:AEObasicData.CUS_UNIT, // 计量单位
            currencyList:AEObasicData.CUS_MAPPING_CURRENCY_CODE_V, // 币制列表
            countryList: [], // 国家
            inWarehouseRows:{}, // 货物行选中信息
            addGoodsForm:{
                interId:'',// 父任务单id
                rowStatus: '', // 状态   
                goodsName: '', // 货物名称
                hsCode: '', // 货物编码
                goodsType: '', // 货物类别
                packageType:'', // 包装
                spec:'', // 规格
                qty1:'', // 件数1
                qty1Unit:'', // 件数1单位
                qty2:'', // 件数2
                qty2Unit:'', // 件数2单位
                decPrice:'', // 单价
                decAmount:'', // 总价（申报金额）
                netWeight:'', // 净重
                vol:'', // 体积
                decNum:'', // 申报数量
                decUnit:'', // 申报单位代码
                decCurrency:'', // 币制
                originCountry:'', // 原产地
                firstNum:'', // 法一数
                lawUnitFirst:'', // 法一单位
                secondNum:'', // 法二数
                lawUnitSecond:'', // 法二单位
                // sealNo:'', // 铅封号
                // boxNo:'', // 箱号
                itemNo:'', // 项号
                skuNo:'', // 商品料号
                // driver :'', // 司机
                // truckNo :'', // 车牌
            },
            // 表体保存规则
            inWarehouseRules:{
                goodsName: [
                    { required: true, message: '请选择货物名称', trigger: 'change' }
                ],
                spec: [
                    { required: true, message: '请输入规格型号', trigger: 'blur' }
                ],
                goodsPart: [
                    { required: true, message: '请输入商品料号', trigger: 'blur' }
                ],
                netWeight: [
                    { required: true, message: '请输入净重', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ],
                qty1: [
                    { required: true, message: '请输入件数', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ],
                qty1Unit:[
                    { required: true, message: '请选择件数1单位', trigger: 'change' }
                ],
                decUnit: [
                    { required: true, message: '请选择申报单位', trigger: 'change' }
                ],
                decPrice:[
                    { required: true, message: '请输入单价', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ],
                decNum:[
                    { required: true, message: '请输入申报数量', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ],
                decAmount:[
                    { required: true, message: '请输入申报金额', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ],
                decCurrency:[
                    { required: true, message: '请选择币制', trigger: 'change' }
                ],
                firstNum:[
                    { required: true, message: '请输入法定第一数量', trigger: 'blur' },
                    { validator: inWarehouseRulesZero, trigger: "blur" }
                ]
            },
            // 下发任务弹窗
            IssueGoodsVisible:false,
            // 下发任务表单
            issueGoodsForm:{
                taskType:'入库作业', // 任务类型
                place:'', // 库区
                location:'', // 库位
                storekeeper:'', // 理货员
                firstNum:'', // 法一数量
                secondNum:'', // 法二数量
                netWeight:'', // 净重
                qty1:'', // 件1
                qty2:'', // 件2
                decNum:'', // 申报数量
                vol:'', // 体积
                decAmount:0, // 申报金额
                driver:'', // 司机
                truckNo :'', // 车牌
                sealNo:'', // 铅封号
                boxNo:'', // 箱号

            },
            IssueGoodsData:[], // 下发任务表格
            storekeeperList:[
                {
                    name:'孙志军'
                },{
                    name:'李永亮'
                }
            ], // 理货员列表
            issueGoodsFormRules:{ // 下发表单规则
                storekeeper:[
                    { required: true, message: '请选择理货员', trigger: 'change' }
                ],
                place:[
                    { required: true, message: '请选择库区', trigger: 'change' }
                ],
                location:[
                    { required: true, message: '请选择库位', trigger: 'change' }
                ],
                driver:[
                    { required: true, message: '请输入司机', trigger: 'blur' },
                ],
                truckNo:[
                    { required: true, message: '请输入车牌', trigger: 'blur' },
                ],
                netWeight:[
                    { required: true, message: '请输入净重', trigger: 'blur' },
                    { validator: validateNetWeight, trigger: "blur" }
                ],
                qty1:[
                    { required: true, message: '请输入件数1', trigger: 'blur' },
                    { validator: validateQty1, trigger: "blur" }
                ],
                qty2:[
                    { required: true, message: '请输入件数2', trigger: 'blur' },
                    { validator: validateQty2, trigger: "blur" }
                ],
                decNum:[
                    { required: true, message: '请输入申报数量', trigger: 'blur' },
                    { validator: validateDecNum, trigger: "blur" }
                ],
                firstNum:[
                    { required: true, message: '请输入法定第一数量', trigger: 'blur' },
                    { validator: validateFirstNum, trigger: "blur" }
                ],
                secondNum:[
                    { required: true, message: '请输入法定第二数量', trigger: 'blur' },
                    { validator: validateSecondNum, trigger: "blur" }
                ],
                vol:[
                    { required: true, message: '请输入体积', trigger: 'blur' },
                    { validator: validateVol, trigger: "blur" }
                ],
                decAmount:[
                    { required: true, message: '请输入申报金额', trigger: 'blur' },
                    { validator: validateDecAmount, trigger: "blur" }
                ],
                
            }
        }
    },
    created() {
        window.addEventListener('message', (event) => {
            if (event.source === window) {
                // 当页面消息来自自己时（F5刷新）并且hasHandledToken为false时（证明是第一次执行，保证接口只调用一次）
                if(localStorage.getItem('id') && !this.hasHandledToken){
                    this.inWarehouseCustomConfig = this.customConfig // 表格定义列
                    this.getIsBonded()
                    this.getckNameList()
                    this.getCompanyList()
                    this.getBoxTypeList()
                    this.getWMSTaskDetail(localStorage.getItem('id'))
                }
                return false
            }
            // 父页面消息
            this.handleMessage(event);
        });
    },
    mounted() {
        // 获取当前日期
         this.warehousingForm.createDate = new Date().toISOString().split('T')[0] // 格式化为 "2026-02-03"
        // 监听页面关闭
    },
    methods: {
        // 通用查找方法
        findNameByCode(code, list) {
            if (!code) return '';
            const item = list.find(item => item.codeValue === code);
            return item ? item.codeName : code; // 找不到就返回原编码
        },
        // 处理整个数组的数据转换
        processTableData(data) {
            return data.map(item => ({
            ...item,
            decCurrencyName: this.findNameByCode(item.decCurrency, this.currencyList), // 币制
            originCountryName: this.findNameByCode(item.originCountry, AEObasicData.CUS_MAPPING_COUNTRY_CODE_V), // 原产地
            lawUnitFirstName: this.findNameByCode(item.lawUnitFirst, AEObasicData.CUS_UNIT), // 法一单位
            lawUnitSecondName: this.findNameByCode(item.lawUnitSecond, AEObasicData.CUS_UNIT), // 法二单位
            decUnitName: this.findNameByCode(item.decUnit, AEObasicData.CUS_UNIT), // 申报单位
            qty1UnitName: this.findNameByCode(item.qty1Unit, this.unitList), // 件数1单位
            qty2UnitName: this.findNameByCode(item.qty2Unit, this.unitList), // 件数2单位
            // packageTypeName: this.findNameByCode(item.packageType, this.lawUnitList), // 包装
            }));
        },
        // 接收父窗口的消息
        handleMessage(event) {
            console.log(event)
                if(event.data.type === 'SET_TOKEN' && !this.hasHandledToken) {
                    this.hasHandledToken = true;
                    localStorage.clear();
                    console.log('接收到来自子窗口的消息：', event.data);
                    localStorage.setItem('token', event.data.token);
                    localStorage.setItem('name', event.data.name);
                    // 向父窗口发送消息
                    event.source.postMessage(
                        { type: 'TOKEN_RECEIVED' },
                        event.origin
                    );
                    Promise.resolve().then(() => {
                        this.inWarehouseCustomConfig = this.customConfig // 表格定义列
                        this.getIsBonded()
                        this.getckNameList()
                        this.getCompanyList()
                        this.getBoxTypeList()
                        if(event.data.id !== ''){
                            localStorage.setItem('id', event.data.id);
                            this.getWMSTaskDetail(localStorage.getItem('id'))
                        }else{
                            this.warehousingForm.createUser = event.data.name
                        }
                    })
                }
        },
        // 查询任务单详情
        getWMSTaskDetail(id){
            this.$api.getWMSTaskDetail(id).then(res =>{
                this.warehousingForm = res.taskMain
                //查询inWarehouseData中编码对应的汉字
                this.inWarehouseData = this.processTableData(res.taskSub.tableData);
                this.inWarehouseColumns = res.taskSub.columns
                // 当下方货物信息列表中有信息的时候，禁止编辑表头
                // if(this.inWarehouseData.length){
                //     this.warehousingFormExit = true
                // }else{
                //     this.warehousingFormExit = false
                // }
                
            })
        },
        // 获取箱型列表
        getBoxTypeList(){
            this.$api.getDicList( { value:'箱型'} ).then(res =>{
                this.boxTypeList = res
            })
        },
        // 获取保税属性
        getIsBonded(){
            this.$api.getDicList( { value:'Wms保税属性'} ).then(res =>{
                this.bondedTypeList = res
            })
        },
        // 获取仓库
        getckNameList(){
            this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
            })
        },
        // 获取客户信息
        getCompanyList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 查询账册
        gethandBookNoList(){
            const parms = {
                type:this.warehousingForm.isBonded,
                ckName:this.warehousingForm.ckName
            }
            this.$api.wmsgetHandBook( parms ).then(res =>{
                this.handBookNoList = res.tableData
                if(this.handBookNoList.length){
                    this.warehousingForm.handbook = this.handBookNoList[0].bookNo
                }else{
                    this.warehousingForm.handbook = ''
                }
                // 默认赋值第一个
            })
        },
        // 当非保税的时候清空报关单号和核注清单,查询账册
        changeIsBonded(){
            if( this.warehousingForm.isBonded &&  this.warehousingForm.ckName){
                this.gethandBookNoList()
            }
            if( this.warehousingForm.isBonded === '非保税' ){
                this.warehousingForm.cusDeclNo = ''
                this.warehousingForm.invDecNo = ''
            }
        },
        changeCkName(){
            if( this.warehousingForm.isBonded &&  this.warehousingForm.ckName){
                this.gethandBookNoList()
            }
        },
        // 当选择客户的时候自动给货主赋值
        changeCustomer(){
            this.warehousingForm.ownerName = this.warehousingForm.customer
        },
        // 保存入库任务单
        warehousingSave(){
            // 判断是否有BillNo
            if(!this.warehousingForm.billNo){
                this.getWMSBillNo()
            }else{
                this.warehousingSaveMain()

            }
        },
        // 保存入库任务单表头
        getWMSBillNo(){
            // 先获取入库单号
            this.$api.getWMSBillNo( 'RK' ).then(res =>{
                this.warehousingForm.billNo = res
                this.warehousingSaveMain()
            })
            
        },
        // 调用保存入库任务单接口
        warehousingSaveMain(){
            this.$refs.warehousingForm.validate((valid) => {
                if (valid) {
                    this.$api.saveMain( this.warehousingForm ).then(res =>{
                        // 存id
                        if(localStorage.getItem('id')){
                            localStorage.setItem('id', res);
                        }
                        this.getWMSTaskDetail(res)
                        this.$message.success('保存成功')
                    })
                } else {
                    this.$message.error('请填写必填字段')
                    return false;
                }
            });
        },
        // 删除任务单
        warehousingDel(){
            this.$confirm('是否确定是删除此任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.deleteWMSTask( this.warehousingForm.id ).then(res =>{
                    this.$message.success('删除成功')
                    // 关闭此页面
                    window.close();
                })
            }).catch(() => { });  
        },
        // 新增货物计划信息
        addRows(){
           this.addGoodsVisible = true
           this.addGoodsForm.rowStatus = '新建'
           this.addGoodsForm.interId = this.warehousingForm.id
           this.addGoodsForm.skuNo = this.warehousingForm.blNo  
        },
        // 获取货物计划列表
        getGoodsList(value){
            this.$api.wmsgetListBy( 1,100,{param:value} ).then(res =>{
                this.goodsList = res.tableData
            })
        }, 
        // 当选择货物名称后赋值给类型和编码 
        goodsEnter(value){
            if(value === ''){
                this.addGoodsForm.goodsName = ''
                this.addGoodsForm.goodsType = ''
                this.addGoodsForm.hsCode = ''
                this.addGoodsForm.lawUnitFirst = ''
            }else{
                const item  = value.split('-')
                this.addGoodsForm.goodsName = item[0]
                this.addGoodsForm.goodsType = item[1]
                this.addGoodsForm.hsCode = item[2]
                // 根据海关编码查询法一、法二、申报单位
                this.$api.getHsCiqByHsCode(  item[2]  ).then(res =>{
                    // this.unitList = AEObasicData.CUS_UNIT.filter(item =>
                    //     item.codeName.toLowerCase().includes(res.firstLawUnit.toLowerCase()) || 
                    //     item.codeName.toLowerCase().includes(res.hsUnit.toLowerCase()) || 
                    //     item.codeName.toLowerCase().includes(res.firstLawUnit.toLowerCase()) 
                    // )
                    this.addGoodsForm.lawUnitFirst = AEObasicData.CUS_UNIT.filter(item =>
                        item.codeName.toLowerCase().includes(res.firstLawUnit.toLowerCase())
                    )[0].codeValue
                    this.addGoodsForm.decUnit = AEObasicData.CUS_UNIT.filter(item =>
                        item.codeName.toLowerCase().includes(res.hsUnit.toLowerCase())
                    )[0].codeValue
                    this.addGoodsForm.lawUnitSecond = (res.secondLawUnit === '无' || res.secondLawUnit === '') ? '' :  AEObasicData.CUS_UNIT.filter(item =>
                        item.codeName.toLowerCase().includes(res.secondLawUnit.toLowerCase())
                    )[0].codeValue
                    // this.addGoodsForm.lawUnitFirst = res.firstLawUnit
                    // this.addGoodsForm.decUnit = res.hsUnit
                    // this.addGoodsForm.lawUnitSecond = res.secondLawUnit === '无' ? '' : res.secondLawUnit
                })
            }
        },
        // 查询计量单位
        // getUnitList(value){
            // if(value && value !== ' '){
            //     this.unitList = AEObasicData.CUS_UNIT.filter(item =>
            //         item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
            //         item.codeName.toLowerCase().includes(value.toLowerCase())
            //     );
            // }
        // },
        // 查询国家
        getCountryList(value){
            if(value && value !== ' '){
                this.countryList = AEObasicData.CUS_MAPPING_COUNTRY_CODE_V.filter(item =>
                    item.codeValue.toLowerCase().includes(value.toLowerCase()) ||
                    item.codeName.toLowerCase().includes(value.toLowerCase()) || 
                    item.cusCode.toLowerCase().includes(value.toLowerCase())
                );
            }
        },
        // 关闭新增货物信息弹窗
        addGoodsClose(){
            this.addGoodsVisible = false
            this.addGoodsForm = {}
            this.$refs.addGoodsForm.resetFields();
        },
        // 保存新增货物信息
        saveAddGoods(){
            this.$refs.addGoodsForm.validate((valid) => {
                if (valid) {
                    this.addGoodsForm.blNo = this.warehousingForm.blNo
                    this.$api.insOneRecordWMSTask(this.addGoodsForm).then(res =>{
                        this.$message.success('保存成功')
                        this.addGoodsClose()
                        this.getWMSTaskDetail(this.warehousingForm.id)
                        // 清空行选中值 
                        this.inWarehouseRows = {}
                    })
                } else {
                    this.$message.error('请填写必填字段')
                    return false;
                }
            })
        },
        // 输入货物计划中净重时，同时修改第一法定数量和申报数量,如果单价有值则计算申报金额
        blurNetWeight(){
            this.addGoodsForm.firstNum =  this.addGoodsForm.lawUnitFirst !== '' ? this.addGoodsForm.netWeight : ''
            this.addGoodsForm.decNum = this.addGoodsForm.netWeight
            if(this.addGoodsForm.decPrice){
                this.addGoodsForm.decAmount = this.addGoodsForm.netWeight * this.addGoodsForm.decPrice
            }
        },
        // 输入货物计划中单价时，如果净重有值则计算申报金额
        blurDecPrice(){
          if(this.addGoodsForm.netWeight){
                this.addGoodsForm.decAmount = this.addGoodsForm.netWeight * this.addGoodsForm.decPrice
            }  
        },
        // 货物行选中
        inWarehouseRowsChange( { row }){
            this.inWarehouseRows = row
            // 查询下发任务列表
            this.wmsGetOpsBySubId(row.id)
        },
        // 编辑货物计划信息
        exitRows(){
            // 判断是否选中行数据
            if( !this.inWarehouseRows.id ){
                this.$message({
                    message: '请先选中计划信息',
                    type: 'warning'
                });
                return false
            }
            // 判断选中的行信息是否可以编辑，如果是新建则可以编辑全部信息，如果是完成或下发只能编辑项号
            if(this.inWarehouseRows.rowStatus === '新建'){
                this.addGoodsExit = true
                // this.$message({
                //     message: '此计划信息不可编辑',
                //     type: 'warning'
                // });
                // return false
            }else{
                // 只能编辑项号
                this.addGoodsExit = false
            }
            this.addGoodsVisible = true
            this.addGoodsForm =  JSON.parse(JSON.stringify(this.inWarehouseRows))
            // 查询原产国
            this.getCountryList(this.addGoodsForm.originCountry)
        },
        // 删除货物信息
        delRows(){
            if( !this.inWarehouseRows.id ){
                this.$message({
                    message: '请先选中货物信息',
                    type: 'warning'
                });
                return false
            }
            this.$confirm('是否确定删除此行货物信息?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // this.$api.deleteWMSTask( this.warehousingForm.id ).then(res =>{
                    this.$message.success('删除成功')
                    // 刷新数据
                    // this.getWMSTaskDetail(this.warehousingForm.id)
                // })
            }).catch(() => { });  
        },
        // 复制行货物信息
        copyRows(){
            if( !this.inWarehouseRows.id ){
                this.$message({
                    message: '请先选中货物信息',
                    type: 'warning'
                });
                return false
            }
            this.addGoodsVisible = true
            const {workedAmount,workedDecNum,workedFirstNum,workedNetWeight,workedQty1,workedQty2,workedSecondNum,workedVol, ...param } = this.inWarehouseRows
            this.addGoodsForm = param
            this.addGoodsForm.id = null
            this.addGoodsForm.rowStatus = null
            // 如果是新建状态则可以编辑
            this.inWarehouseRowsExit = true
        },
        // 下发暂存
        IssueRowsSave(){
            // 判断是否选中行数据
            if( !this.inWarehouseRows.id ){
                this.$message({
                    message: '请先选中计划信息',
                    type: 'warning'
                });
                return false
            }
            // 判断选中计划信息是否可以下发暂存
            if(this.inWarehouseRows.rowStatus === '已指派' ||  this.inWarehouseRows.rowStatus === '完成' ){ 
                this.$message({
                    message: '此计划信息不可下发暂存',
                    type: 'warning'
                });
                return false
            }
            this.IssueGoodsVisible = true
            // 将下发信息的净重和件数修改为可以下发的最大值
            this.issueGoodsForm.decAmount = this.inWarehouseRows.decAmount ? parseFloat(this.inWarehouseRows.decAmount) - parseFloat(this.inWarehouseRows.workedAmount) :''
            this.issueGoodsForm.vol = this.inWarehouseRows.vol ? parseFloat(this.inWarehouseRows.vol) - parseFloat(this.inWarehouseRows.workedVol) : ''
            this.issueGoodsForm.netWeight = parseFloat(this.inWarehouseRows.netWeight) - parseFloat(this.inWarehouseRows.workedNetWeight)
            this.issueGoodsForm.decNum = this.inWarehouseRows.decNum? parseFloat(this.inWarehouseRows.decNum) - parseFloat(this.inWarehouseRows.workedDecNum) :''
            console.log(this.issueGoodsForm.decNum)
            this.issueGoodsForm.firstNum = parseFloat(this.inWarehouseRows.firstNum) - parseFloat(this.inWarehouseRows.workedFirstNum)
            this.issueGoodsForm.secondNum = this.inWarehouseRows.secondNum ? parseFloat(this.inWarehouseRows.secondNum) - parseFloat(this.inWarehouseRows.workedSecondNum) : ''
            this.issueGoodsForm.qty1 = parseFloat(this.inWarehouseRows.qty1) - parseFloat(this.inWarehouseRows.workedQty1)
            this.issueGoodsForm.qty2 =  this.inWarehouseRows.qty2 ?  parseFloat(this.inWarehouseRows.qty2) - parseFloat(this.inWarehouseRows.workedQty2) : ''
            // 获取库区信息
           this.getStore()
        },
        // 获取库区列表
        getStore(){
            this.$api.getStore( this.warehousingForm.ckName ).then(res =>{
                this.placeList = res
            })
        },
        // 根据库区查询库位列表
        placeEnter(value){
            if(value === ''){
                this.issueGoodsForm.place = ''
                this.locationList = []
            }else{
                const item  = value.split('-')
                this.issueGoodsForm.place = item[0]
                this.getLocation(item[1])
            }
            this.issueGoodsForm.location = ''
        },
        // 查询库位列表
        getLocation(id){
            this.$api.getLocation( id ).then(res =>{
                this.locationList = res
            })
        },
        // 关闭下发任务弹窗
        IssueGoodsClose(){
            this.IssueGoodsVisible = false
            // this.issueGoodsForm = {}
            this.$refs.issueGoodsForm.resetFields();
            this.issueGoodsForm.decAmount = 0
            // 查询下发任务
        },
        // 修改下发暂存的时候件数1，同步修改净重、申报数量、申报金额
        blurQty1(){
            this.issueGoodsForm.netWeight = this.calculateAllPlanFields(this.inWarehouseRows.netWeight)
            this.issueGoodsForm.decNum = this.calculateAllPlanFields(this.inWarehouseRows.decNum)
            this.issueGoodsForm.firstNum = this.calculateAllPlanFields(this.inWarehouseRows.firstNum)
            this.issueGoodsForm.secondNum = this.calculateAllPlanFields(this.inWarehouseRows.secondNum)
            this.issueGoodsForm.vol = this.calculateAllPlanFields(this.inWarehouseRows.vol)
            this.issueGoodsForm.decAmount = this.calculateAllPlanFields(this.inWarehouseRows.decAmount)
        },
        // 净重、申报数量、金额、件数2，法一，法二 计算
        calculateAllPlanFields(number){
            if(!number){
                return null
            }else{
                const value = Number(number) || 0;
                const qty1 = Number(this.inWarehouseRows.qty1); // 选中数据的件数1
                const planQty1 = Number(this.issueGoodsForm.qty1); // 填写出库的件数1
                // 计算并保留指定位小数
                const result = (value / qty1) * planQty1;
                const factor = Math.pow(10, 4);  // 10000
                // Number.EPSILON  大约是 2.220446049250313e-16 这是 JavaScript 中最小的正数用于解决浮点数计算中的精度问题
                return Math.round((result + Number.EPSILON) * factor) / factor;  // 加一个极小的数，避免浮点数误差;乘以10^4，将小数变为整数,四舍五入
            }
        },
        // 保存下发暂存任务弹窗
        saveIssueGoods(){
            // 判断
            this.$refs.issueGoodsForm.validate((valid) => {
                if (valid) {
                    // 删除id，worked
                    const { id,interId, workedAmount,workedDecNum,workedFirstNum,workedNetWeight,workedQty1,workedQty2,workedSecondNum,workedVol,
                        completeDate,completeTime,createDate,createTime,rowStatus,  ...param } = this.inWarehouseRows
                    // 合并 issueGoodsForm
                    Object.assign(param, this.issueGoodsForm);
                    param.interId = this.inWarehouseRows.id
                    // 将仓库,报关单号,核注清单号,客户,货主赋值给param
                    param.ckName = this.warehousingForm.ckName
                    param.cusDeclNo = this.warehousingForm.cusDeclNo
                    param.invDecNo = this.warehousingForm.invDecNo
                    param.customer = this.warehousingForm.customer
                    param.ownerName = this.warehousingForm.ownerName
                    param.handbook = this.warehousingForm.handbook
                    param.isBonded = this.warehousingForm.isBonded
                    this.$api.wmsSaveOpTask( param ).then(res =>{
                        // 关闭弹窗
                        this.IssueGoodsClose()
                        // 重新查询主任务
                        this.getWMSTaskDetail(this.warehousingForm.id)
                        // 查询下发任务列表
                        this.wmsGetOpsBySubId(param.interId)
                        // 清空表格选中
                        this.inWarehouseRows = {}
                    })
                } else {
                    this.$message.error('请填写必填字段')
                    return false;
                }
            })
        },
        // 查询下发任务
        wmsGetOpsBySubId(id){
            this.$api.wmsGetOpsBySubId(id).then(res =>{
                this.IssueGoodsData = res
            })
        },
        // 查询所有下发任务
        getIssueAll(){
            this.$api.wmsGetOpsByTaskId(this.warehousingForm.id).then(res =>{
                this.IssueGoodsData = res
                // 货物信息列表取消选中
                this.$refs.inWarehouseTable.clearRadioRow()
                this.inWarehouseRows = {}
            })

        },
        // 下发任务到手持端
        IssueRows(row){
            this.$confirm('是否推送作业任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmspushOpTask(row.id).then(res =>{
                    this.$message({
                        type: 'success',
                        message: '推送成功!'
                    });
                    // 更新数据
                    this.wmsGetOpsBySubId(row.interId)
                })
            }).catch(() => {      
            });
        },
        // 完成入库
        completeRows(row){
            this.$confirm('是否确认完成此作业任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmsinBoundTask(row).then(res =>{
                    this.$message({
                        type: 'success',
                        message: '作业任务已成功'
                    });
                    // 更新数据
                    this.wmsGetOpsBySubId(row.interId)
                    this.getWMSTaskDetail(this.warehousingForm.id)
                })
            }).catch(() => {      
            });
        },
    },
    // beforeDestroy() {
    destroyed() {
        localStorage.clear();
        window.removeEventListener('message', this.handleMessage);
    }
}
</script>
<style style lang="less" scoped>
.width_100{
    width: 100%;
}
.margin_right_20{
    margin-right: 20px;
}
.warehousingForm{
    margin: 10px;
}
.mini_button{
    padding: 3px 8px !important;
}
// 表头样式
.warehousingForm .el-col-4{
    padding-left: 8px !important;
    padding-right: 8px !important;
}
.warehousingForm .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    // margin-bottom: 3px !important;
    margin-right: 5px !important;
}
.el-form-item__content{
    width: 100% !important;
}
.el-form-item__label{
    color: black;
}
// 分割线颜色
.el-divider__text{
    color: #797c81 !important;
}
.el-divider--horizontal {
    margin: 10px 0;
}
// 按钮
.buttons_box{
    margin: 5px 15px;
    display: flex;
    align-items: center;
}
// 表格按钮样式
.vxe-toolbar{
    padding: 0px;
}
// 控制弹窗表单高度
.goods_form  {
  max-height: 62vh;
  /* 垂直方向超出滚动，水平方向隐藏 */
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box; /* 内边距计入高度，避免高度溢出 */
}
.tipText{
    font-size: 12px;
    font-weight: bold;
    margin-left: 5px;
}
.form_item_60{
    width: 60%;
}

</style>